import React from 'react';
import PropTypes from 'prop-types';

/**
 * @param {object} props - Props.
 * @returns {JSX.Element} Component.
 */
export const StatsSectionContentHeaderBelow = ( { children } ) => {
    if ( !React.Children.toArray( children ).find( child => !!child ) ) {
        return <></>;
    }
    
    return (
        <>
            { children && (
                <div className="stats-section-header-below">
                    { React.Children.map( children, child => (
                        <div className="stats-section-header-below__item">
                            { child }
                        </div>
                    ) ) }
                </div>
            ) }
        </>
    );
};

StatsSectionContentHeaderBelow.defaultProps = {
    name: 'StatsSectionContentHeaderBelow'
};

StatsSectionContentHeaderBelow.propTypes = {
    children: PropTypes.any
};